export default "__VITE_PUBLIC_ASSET__8ea5c337__"